var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.visible),expression:"!visible"}],attrs:{"color":"primary","dark":"","fixed":"","bottom":"","right":"","fab":""},on:{"click":_vm.action}},[_c('v-icon',[_vm._v("mdi-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }